module.exports = __webpack_public_path__ + "img/eamc-logo.a60a532b.jpg";